import { SaplingLogo } from '@/components/icons/SaplingLogo';
import { cn } from '@/lib/utils';

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={cn(
        'border-t bg-background py-8',
        className
      )}
    >
      <div className="container">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          {/* Logo and tagline */}
          <div className="flex flex-col items-center sm:items-start gap-2">
            <SaplingLogo size="sm" />
            <p className="text-sm text-muted-foreground">
              Simple accounting that grows with you
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
            <a
              href="https://oasisautokonnect.com/sapling"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Learn More
            </a>
            <a
              href="https://oasisautokonnect.com/pages/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Privacy
            </a>
            <a
              href="https://oasisautokonnect.com/pages/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors"
            >
              Terms
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-6 pt-6 border-t text-center text-sm text-muted-foreground">
          <p>
            &copy; {currentYear} Oasis Auto Konnect, LLC. All rights reserved.
          </p>
          <p className="mt-1">
            Part of the{' '}
            <a
              href="https://oasisautokonnect.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sapling-primary-200 hover:text-sapling-primary-100 dark:text-sapling-primary-100 dark:hover:text-sapling-primary-100"
            >
              OAK family
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
